/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Users",
  size: 20
}

const SvgUsers = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <circle fill="none" strokeWidth={1.1} cx={7.7} cy={8.6} r={3.5} />
    <path
      fill="none"
      strokeWidth={1.1}
      d="M1 18.1c.7-3.5 3.4-6 6.6-6 3.3 0 6.1 2.7 6.7 6.2M11.4 4c1.4-1.6 4-1.2 4.9.7.9 1.9-.6 4.2-2.7 4.2 2.9 0 5.2 2.4 5.6 5.2"
    />
  </Svg>
)

SvgUsers.defaultProps = defaultProps
export default SvgUsers
